<template>
  <div class="redirection">
    <img class="redirection_logo" src="/img/redirection_logo.png"/>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Redirection extends Vue {
}
</script>
<style lang="stylus">
.redirection {
  height : 100%
  width : 100%
  background-image : url("/public/img/redirection_bg.png");
  background-position: center;

  .redirection_logo {
    position: absolute;
    margin-left: -511px
    margin-top: -212px
    top: 50%;
    left: 50%
  }
}
</style>
